// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ReviewRouteImport } from './routes/review'
import { Route as PressRouteImport } from './routes/press'
import { Route as DiscordRouteImport } from './routes/discord'
import { Route as AppstoreRouteImport } from './routes/appstore'
import { Route as AppStoreRouteImport } from './routes/app-store'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as Wrapped2025RouteImport } from './routes/wrapped/2025'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutTutorialRouteImport } from './routes/_layout/tutorial'
import { Route as LayoutTestMediaSessionRouteImport } from './routes/_layout/test-media-session'
import { Route as LayoutSigninRouteImport } from './routes/_layout/signin'
import { Route as LayoutRedeemRouteImport } from './routes/_layout/redeem'
import { Route as LayoutPrivacyRouteImport } from './routes/_layout/privacy'
import { Route as LayoutIosRouteImport } from './routes/_layout/ios'
import { Route as LayoutEmbedRouteImport } from './routes/_layout/embed'
import { Route as LayoutBuyRouteImport } from './routes/_layout/buy'
import { Route as LayoutAboutRouteImport } from './routes/_layout/about'
import { Route as EmbedUsernameStationSlugRouteImport } from './routes/embed/$username/$stationSlug'
import { Route as LayoutTutorialsIndexRouteImport } from './routes/_layout/tutorials/index'
import { Route as LayoutBlogIndexRouteImport } from './routes/_layout/blog/index'
import { Route as LayoutUsernameIndexRouteImport } from './routes/_layout/$username/index'
import { Route as LayoutTutorialsSlugRouteImport } from './routes/_layout/tutorials/$slug'
import { Route as LayoutStationStationIdRouteImport } from './routes/_layout/station.$stationId'
import { Route as LayoutSettingsDomainsRouteImport } from './routes/_layout/settings/domains'
import { Route as LayoutCheckoutSuccessRouteImport } from './routes/_layout/checkout/success'
import { Route as LayoutBlogSlugRouteImport } from './routes/_layout/blog/$slug'
import { Route as LayoutUsernameStationSlugRouteImport } from './routes/_layout/$username/$stationSlug'

const ReviewRoute = ReviewRouteImport.update({
            id: '/review',path: '/review',getParentRoute: () => rootRouteImport
          })
const PressRoute = PressRouteImport.update({
            id: '/press',path: '/press',getParentRoute: () => rootRouteImport
          })
const DiscordRoute = DiscordRouteImport.update({
            id: '/discord',path: '/discord',getParentRoute: () => rootRouteImport
          })
const AppstoreRoute = AppstoreRouteImport.update({
            id: '/appstore',path: '/appstore',getParentRoute: () => rootRouteImport
          })
const AppStoreRoute = AppStoreRouteImport.update({
            id: '/app-store',path: '/app-store',getParentRoute: () => rootRouteImport
          })
const LayoutRoute = LayoutRouteImport.update({
            id: '/_layout',getParentRoute: () => rootRouteImport
          })
const Wrapped2025Route = Wrapped2025RouteImport.update({
            id: '/wrapped/2025',path: '/wrapped/2025',getParentRoute: () => rootRouteImport
          })
const LayoutIndexRoute = LayoutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutRoute
          })
const LayoutTutorialRoute = LayoutTutorialRouteImport.update({
            id: '/tutorial',path: '/tutorial',getParentRoute: () => LayoutRoute
          })
const LayoutTestMediaSessionRoute = LayoutTestMediaSessionRouteImport.update({
            id: '/test-media-session',path: '/test-media-session',getParentRoute: () => LayoutRoute
          })
const LayoutSigninRoute = LayoutSigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => LayoutRoute
          })
const LayoutRedeemRoute = LayoutRedeemRouteImport.update({
            id: '/redeem',path: '/redeem',getParentRoute: () => LayoutRoute
          })
const LayoutPrivacyRoute = LayoutPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => LayoutRoute
          })
const LayoutIosRoute = LayoutIosRouteImport.update({
            id: '/ios',path: '/ios',getParentRoute: () => LayoutRoute
          })
const LayoutEmbedRoute = LayoutEmbedRouteImport.update({
            id: '/embed',path: '/embed',getParentRoute: () => LayoutRoute
          })
const LayoutBuyRoute = LayoutBuyRouteImport.update({
            id: '/buy',path: '/buy',getParentRoute: () => LayoutRoute
          })
const LayoutAboutRoute = LayoutAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => LayoutRoute
          })
const EmbedUsernameStationSlugRoute = EmbedUsernameStationSlugRouteImport.update({
            id: '/embed/$username/$stationSlug',path: '/embed/$username/$stationSlug',getParentRoute: () => rootRouteImport
          })
const LayoutTutorialsIndexRoute = LayoutTutorialsIndexRouteImport.update({
            id: '/tutorials/',path: '/tutorials/',getParentRoute: () => LayoutRoute
          })
const LayoutBlogIndexRoute = LayoutBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => LayoutRoute
          })
const LayoutUsernameIndexRoute = LayoutUsernameIndexRouteImport.update({
            id: '/$username/',path: '/$username/',getParentRoute: () => LayoutRoute
          })
const LayoutTutorialsSlugRoute = LayoutTutorialsSlugRouteImport.update({
            id: '/tutorials/$slug',path: '/tutorials/$slug',getParentRoute: () => LayoutRoute
          })
const LayoutStationStationIdRoute = LayoutStationStationIdRouteImport.update({
            id: '/station/$stationId',path: '/station/$stationId',getParentRoute: () => LayoutRoute
          })
const LayoutSettingsDomainsRoute = LayoutSettingsDomainsRouteImport.update({
            id: '/settings/domains',path: '/settings/domains',getParentRoute: () => LayoutRoute
          })
const LayoutCheckoutSuccessRoute = LayoutCheckoutSuccessRouteImport.update({
            id: '/checkout/success',path: '/checkout/success',getParentRoute: () => LayoutRoute
          })
const LayoutBlogSlugRoute = LayoutBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => LayoutRoute
          })
const LayoutUsernameStationSlugRoute = LayoutUsernameStationSlugRouteImport.update({
            id: '/$username/$stationSlug',path: '/$username/$stationSlug',getParentRoute: () => LayoutRoute
          })





const LayoutRouteChildren = {
  LayoutAboutRoute: LayoutAboutRoute,LayoutBuyRoute: LayoutBuyRoute,LayoutEmbedRoute: LayoutEmbedRoute,LayoutIosRoute: LayoutIosRoute,LayoutPrivacyRoute: LayoutPrivacyRoute,LayoutRedeemRoute: LayoutRedeemRoute,LayoutSigninRoute: LayoutSigninRoute,LayoutTestMediaSessionRoute: LayoutTestMediaSessionRoute,LayoutTutorialRoute: LayoutTutorialRoute,LayoutIndexRoute: LayoutIndexRoute,LayoutUsernameStationSlugRoute: LayoutUsernameStationSlugRoute,LayoutBlogSlugRoute: LayoutBlogSlugRoute,LayoutCheckoutSuccessRoute: LayoutCheckoutSuccessRoute,LayoutSettingsDomainsRoute: LayoutSettingsDomainsRoute,LayoutStationStationIdRoute: LayoutStationStationIdRoute,LayoutTutorialsSlugRoute: LayoutTutorialsSlugRoute,LayoutUsernameIndexRoute: LayoutUsernameIndexRoute,LayoutBlogIndexRoute: LayoutBlogIndexRoute,LayoutTutorialsIndexRoute: LayoutTutorialsIndexRoute
}

const LayoutRouteWithChildren = LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,AppStoreRoute: AppStoreRoute,AppstoreRoute: AppstoreRoute,DiscordRoute: DiscordRoute,PressRoute: PressRoute,ReviewRoute: ReviewRoute,Wrapped2025Route: Wrapped2025Route,EmbedUsernameStationSlugRoute: EmbedUsernameStationSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)